import { render, staticRenderFns } from "./4.vue?vue&type=template&id=b1df134c&scoped=true&"
var script = {}
import style0 from "./4.vue?vue&type=style&index=0&id=b1df134c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1df134c",
  null
  
)

export default component.exports